// Copyright (c) 2016 Deere & Company

import { fetch as deereFetch } from '@deere/cps-it.fetch-wrapper';

export async function fetch(input, { headers, ...options }) {

    const language = 'EN';

    const fetchHeaders = {
        ...headers,
        'Accept-Language': language,
    };

    const fetchOptions = {
        headers: fetchHeaders,
        ...options,
    };

    return deereFetch(input, fetchOptions);

}

export function anonFetch(input, options) {

    return deereFetch(input, options);

}
